<script setup lang="ts">
import { computed, ref } from 'vue';
import ConnxButton from '@/components/Atoms/ConnxButton.vue';
import type { ButtonAction } from '@/components/Atoms/ConnxButton.vue';
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';

export interface HeaderQuickActionsProps {
  disableFavourites?: boolean;
  disableHelp?: boolean;
  disablePrint?: boolean;
}

const props = defineProps<HeaderQuickActionsProps>();
const optionsOpen = ref(false);

const baseActionClass = 'tw-bg-connx-white hover:tw-bg-connx-white hover:tw-text-connx-primary';

const actions = computed<ButtonAction[]>(() => {
  const items: ButtonAction[] = [];

  if (!props.disablePrint) {
    items.push({
      text: 'Print',
      icon: 'fas fa-print',
      class: baseActionClass,
      action: () => window?.print?.(),
    });
  }

  if (!props.disableFavourites) {
    items.push({
      text: 'Favourites',
      icon: 'fas fa-heart',
      class: baseActionClass,
      action: () => window?.ShowFavsDiv?.(),
    });
  }

  if (!props.disableHelp) {
    items.push({
      text: 'Help',
      icon: 'fas fa-info-circle',
      class: baseActionClass,
      action: () => window?.ShowHelpDiv?.(),
    });
  }

  return items;
});
</script>

<template>
  <ConnxButton
    type="button"
    button-style="circular"
    dropdown-container-class="tw-bg-connx-danger"
    :dropdown-class="
      [
        'tw-py-2 tw-text-connx-grey-shade-20 hover:tw-bg-connx-primary hover:tw-text-connx-white hover:tw-border-connx-primary',
        optionsOpen ? 'tw-bg-connx-primary tw-text-connx-white tw-border-connx-primary' : '',
      ].join(' ')
    "
    dropdown-position="bottom-left"
    @open="(isOpen: boolean) => (optionsOpen = isOpen)"
    :actions="actions"
  >
    <template #drop-down-icon>
      <ConnxIcon name="far fa-ellipsis-h" class="tw-h-5" />
    </template>
  </ConnxButton>
</template>
